module.exports = __webpack_public_path__ + "insights@2x.jpg";